"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _Loader = _interopRequireDefault(require("../Loader"));
var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["className", "testAttr", "children", "type", "variant", "size", "block", "icon", "iconPosition", "destructive", "disabled", "loading", "onClick", "href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Button = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      className,
      testAttr,
      children,
      type,
      variant,
      size,
      block,
      icon,
      iconPosition,
      destructive,
      disabled,
      loading,
      onClick,
      href
    } = _ref,
    attrs = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const buttonClassName = (0, _cnbuilder.cnb)(_ButtonModule.default.root, {
    [_ButtonModule.default.variant]: Boolean(variant)
  }, {
    [_ButtonModule.default[variant]]: variant
  }, {
    [_ButtonModule.default[size]]: size
  }, {
    [_ButtonModule.default.block]: block
  }, {
    [_ButtonModule.default["".concat(iconPosition, "Icon")]]: Boolean(icon) || loading
  }, {
    [_ButtonModule.default.destructive]: destructive
  }, {
    [_ButtonModule.default.disabled]: disabled && href
  }, className);
  const renderIconOrLoader = () => {
    const loaderProps = {
      testAttrRoot: 'loader',
      inline: true,
      disabled: true,
      size: 'small'
    };
    return loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, _objectSpread({}, loaderProps)) : icon;
  };
  return href ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", _objectSpread(_objectSpread({
    className: buttonClassName,
    "data-testid": testAttr,
    href: href,
    onClick: onClick,
    "aria-disabled": disabled
  }, attrs), {}, {
    children: [iconPosition === 'left' && renderIconOrLoader(), children, iconPosition === 'right' && renderIconOrLoader()]
  })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", _objectSpread(_objectSpread({
    ref: ref,
    className: buttonClassName,
    "data-testid": testAttr,
    type: type,
    disabled: disabled,
    onClick: onClick
  }, attrs), {}, {
    children: [iconPosition === 'left' && renderIconOrLoader(), children, iconPosition === 'right' && renderIconOrLoader()]
  }));
});
Button.defaultProps = {
  testAttr: 'button',
  type: 'button',
  size: 'default',
  iconPosition: 'right'
};
var _default = exports.default = Button;